import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {GetManufacturersResponse} from '@dms/api/core';

import {Nullish} from 'shared/web';

export const getOptionsFromManufacturers = (
  manufacturers: GetManufacturersResponse | Nullish
): Option[] => {
  if (isNil(manufacturers)) {
    return [];
  }

  return manufacturers.map((manufacturer) => ({
    label: manufacturer.name ?? '',
    value: manufacturer.manufacturerId ?? '',
  }));
};
